import { ClientLogRequest } from 'src/WebApiController';

export type PerformanceTrackingConfig = {
  cooldownMs: number;
  windowMs: number;
  threshold: number;
};

export type IAppPerformanceContext = {
  trackEndpoint: <T>(
    endpointName: string,
    promiseFn: Promise<T>,
    onError: (e: Error) => void,
    timeoutMs?: number,
    config?: PerformanceTrackingConfig
  ) => Promise<T>;
  trackComponent: (
    componentName: string,
    config?: PerformanceTrackingConfig
  ) => void;
  trackRenderTime: (componentName: string, renderDurationMs: number) => void;
  performMemoryCleanup: () => void;
  memoryOverThresholdExceeded: undefined | [number, number];
};

export type TrackingData = {
  callTimestamps: number[];
  lastLoggedAt: number;
  totalCalls: number;
};

export enum CheckExcessiveType {
  Component = 'component',
  Endpoint = 'endpoint',
}

export type CheckExcessiveCallsOptions = {
  threshold: number;
  windowMs: number;
  cooldownMs: number;
  errorIdPrefix: string;
  errorMessageTemplate: (
    name: string,
    count: number,
    windowMs: number
  ) => string;
  logEvent: (request: ClientLogRequest) => void;
};
